const ENV = process.env.ENV as EnvType || process.env.UMI_ENV as EnvType
console.log('ENV:', ENV)

// TODO 暂时没有域名所以先用这个请求，到时候需要换
const baseUrls = {
  dev: 'https://quanyi-h5-dev.dragonpass.com.cn',
  prod: 'https://h5-quanyi.dragonpass.com.cn',
  test: 'https://quanyi-h5-test.dragonpass.com.cn',
  uat: 'https://quanyi-h5-uat.dragonpass.com.cn',
  'ali-uat': 'https://quanyi-h5-uat.dragonpass.com.cn',
}

const intlUrls = {
  dev: 'https://global-payment-test.dragonpass.com.cn',
  // test: 'https://global-payment-test.dragonpass.com.cn',
  test: 'https://global-payment-uat.dragonpass.com',
  uat: 'https://global-payment-pre.dragonpass.com',
  prod: 'https://global-payment.dragonpass.com',
  "ali-uat": 'https://global-payment-pre.dragonpass.com',
}

export const baseUrl = baseUrls[ENV]

export const intlUrl = intlUrls[ENV]